import { Input } from 'component/Input'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { env } from 'config/environment'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { demo } from 'page/catalog/store/CatalogStore'
import { userModal } from 'page/catalog/UserModal/store/UserModalStore'

export const PhoneInput = observer(() => {
  const be = demo.it.by_email
  const bc = demo.it.by_card
  const { id, busy } = userModal.it
  const short_phone = id.state === 'short_phone'
  const short_card = id.state === 'short_card'
  const invalid = id.state === 'invalid'
  const exists = id.state === 'exists'
  const error = id.state !== 'unknown' && id.state !== 'good'
  const label = be ? i18n('CustomerEmail') : bc ? i18n('ClientId') : i18n('CustomerPhoneNumber')
  const atelier = env.domain === 'atelier'
  const placeholder = be ? 'customer@email.com' : bc ? '0000' : atelier ? '+1 000 000-0000' : '+7 000 000-00-00'

  const onChange = useLatestCallback((value: string) => {
    if (bc) value = value.replaceAll(/\D/g, '')
    id.change(value)
  })

  const onEnter = useLatestCallback(() => {
    id.enter()
  })

  return <Vertical gap={8}>
    <Typo size={11} medium upper>
      {label}
    </Typo>
    <Input height={48} value={id.text} error={error} disabled={busy}
      onChange={onChange} onEnter={onEnter} placeholder={placeholder} />
    {short_phone && <Typo size={11} error>
      {i18n('PhoneNumberIsTooShort')}
    </Typo>}
    {short_card && <Typo size={11} error>
      {i18n('ClientIdIsTooShort')}
    </Typo>}
    {invalid && <Typo size={11} error>
      {i18n('EnterValidEmail')}
    </Typo>}
    {exists && <Typo size={11} error>
      {i18n('CustomerAlreadyExists')}
    </Typo>}
  </Vertical>
})
